import React from 'react';
// import { useStaticQuery, graphql } from 'gatsby';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'gatsby';
// import MemberBackground from './memberReveal/memberBackground';
// import BackgroundImage from 'gatsby-background-image';

class MemberReveal extends React.Component {
  componentDidMount() {
    if (typeof window !== `undefined`) {
      gsap.registerPlugin(ScrollTrigger);
      gsap.core.globals('ScrollTrigger', ScrollTrigger);
    }
    ScrollTrigger.defaults({
      toggleActions: 'restart pause resume pause',
      markers: false,
    });
    // ZOOM SECTION
    const quoteText = document.querySelectorAll('.quote_text');
    gsap.set(quoteText, { autoAlpha: 0 });

    gsap.to('#zoom_overlay', {
      duration: 2,
      scale: 90,
      autoAlpha: 0,
      ease: 'power2.in',
      scrollTrigger: {
        trigger: '#zoom_container',
        start: 'top top',
        end: '+=2000',
        scrub: true,
        anticipatePin: true,
        pin: true,
        //pinReparent: true,
      },
    });
    gsap.fromTo(
      quoteText,
      { autoAlpha: 0 },
      {
        duration: 3,
        autoAlpha: 1,
        stagger: {
          amount: 1,
        },
        ease: 'expo.inOut',
        scrollTrigger: {
          trigger: '.quote',
          start: 'bottom top',
          end: '+=1500',
          scrub: true,
        },
      }
    );
  }
  render() {
    return (
      <>
        <div id="zoom_container" className="bg">
          <section id="zoom_overlay" className="zoom_panel">
            <svg viewBox="0 0 1600 900" className="reveal--silencer pc">
              <defs>
                <style
                  dangerouslySetInnerHTML={{
                    __html: '\n      .reveal_cls-1{fill:#ffffff;}\n    ',
                  }}
                />
              </defs>
              <g id="layer_2" data-name="layer 2">
                <g id="layer_1-2" data-name="layer 1">
                  <path
                    className="reveal_cls-1"
                    d="M1085.25,421.82c-6.57-.36-13.18-.09-20-.09v20.06c6.81,0,13.41.28,20-.08,5.33-.29,8.18-4.15,8.18-9.95S1090.57,422.11,1085.25,421.82Z"
                  />
                  <path
                    className="reveal_cls-1"
                    d="M0,0V900H1600V0ZM545.17,473.59c-.95,13.12-9.16,24.21-21.42,27.94-15.12,4.61-29.27,2.39-42-7.28-3.06-2.33-4.86-5.05-4.53-9.31.44-5.58.11-11.22.11-17.91,9.27,7.56,18.54,12.46,29.62,13.06,8,.43,12.08-1.52,13.07-6.24.92-4.33-1.55-7-9.05-10.12-6.13-2.52-12.51-4.61-18.28-7.8C479.62,448.74,474,435,477.45,420.12c2.86-12.52,14.1-22,28-23.3,11.32-1.09,22.27-.33,32,6.6,3.5,2.49,5.59,5.21,5.18,9.9-.47,5.28-.11,10.64-.11,15.62-6-2.59-11.74-5.82-17.92-7.54-4.83-1.35-10.18-1.14-15.28-1-3.94.11-7.06,2.28-7.57,6.59-.49,4.12,2.1,6.37,5.57,7.86,6.86,2.95,13.81,5.71,20.54,8.93C540.24,449.7,546.14,460.1,545.17,473.59Zm40.15,28H560.69v-103h24.63Zm80.86-.06H605.69v-103h24.87v80.14h35.62Zm80.57-80H704.59v16.92h38.86v22.3H704.77v17.92h42V501.5H679.58V398.59h67.17Zm101.81,80.27c-8.29,0-16.57.15-24.83-.15-1.24-.05-2.79-2-3.56-3.35-10.9-20-21.68-40-32.76-60.5.56,21.25,1.12,42.29,1.69,63.85H763.89V398.34c8.37,0,16.67-.15,24.94.16,1.25,0,2.8,2,3.56,3.43,10.49,19.62,20.86,39.31,31.27,59a21.76,21.76,0,0,0,1.49,2c-.58-21.84-1.14-42.8-1.72-64.17h25.13Zm85.58-3c-27.19,12.62-59.42,1.38-68-30.67-4.78-18-3.35-35.3,7.07-51.16,10.75-16.37,29.81-23.85,49.17-19.68a53.41,53.41,0,0,1,5.32,1.26c10.3,3.3,11.57,5,11.57,15.67v12.37c-16.49-8.19-32.64-11.6-45.55,5.31-7.69,10.07-6.23,29.42,1.71,38.94,9,10.84,22.51,11.55,44.78,2.15,0,5.59-.46,10.8.12,15.89C941,494.22,938.28,496.87,934.14,498.79Zm88.63-77.46H980.58v17.1h38.75v22.3H980.76v17.92h42v22.86H955.39V398.68h67.38Zm73.69,80.29c-1.33,0-2.94-1.8-3.82-3.15-8.93-13.8-17.74-27.68-27.4-42.83v45.91H1039.9V398.34c2.37,0,4.67,0,7,0,14.49.12,29-.06,43.48.47,15.68.57,26.54,11,27.92,26,1.54,16.83-6.34,28.17-22.34,32.17a9.87,9.87,0,0,0-1.41.84l29,44C1114,501.77,1105.22,501.9,1096.46,501.62Z"
                  />
                </g>
              </g>
            </svg>
            <svg viewBox="0 0 2189 3836" className="reveal--silencer sp">
              <defs>
                <style
                  dangerouslySetInnerHTML={{
                    __html: '\n      .memberSp_cls-1{fill:#fff;}\n    ',
                  }}
                />
              </defs>
              <g id="layer_2" data-name="layer 2">
                <g id="layer_1-2" data-name="layer 1">
                  <path
                    className="memberSp_cls-1"
                    d="M1576.08,1869.9c-4.48-.27-9-.05-13.5-.05v-.21c-3.94,0-7.9.29-11.81-.07-5.18-.47-7.61.78-7.17,6.7a215.78,215.78,0,0,1,.06,22.75c-.12,3.82.74,5.57,5,5.4,9-.36,18,0,27-.35,10.88-.47,16.22-6.43,16.15-17.32C1591.78,1876.34,1586.46,1870.53,1576.08,1869.9Z"
                  />
                  <path
                    className="memberSp_cls-1"
                    d="M0,0V3836H2189V0ZM662.53,1957.82c-1.61,22.23-15.54,41-36.32,47.29-25.63,7.77-49.6,4-71.19-12.36-5.21-4-8.22-8.57-7.66-15.76.73-9.45.18-19,.18-30.29,15.74,12.81,31.44,21.09,50.24,22.1,13.47.73,20.47-2.59,22.13-10.59,1.53-7.33-2.62-12-15.37-17.1-10.42-4.2-21.31-7.25-31.1-13-21.76-12.83-31.46-35.64-25.68-60.84,4.86-21.2,23.94-37.17,47.48-39.43,19.19-1.83,37.75-.54,54.25,11.19,5.94,4.22,9.43,8.86,8.74,16.78-.78,9-.18,18-.18,28.58-9.83-7.16-19.16-13.2-30.31-15.32-8.89-1.69-17.72-3.31-26.84-1.32-6.38,1.39-11.15,4.4-12,11.21-.78,6.52,3.1,10.51,8.71,13,11.85,5.17,23.92,9.89,35.58,15.45C654.19,1917.35,664.19,1935,662.53,1957.82Zm68.66,42.87c0,3.53-.82,5-4.65,4.88-10.72-.23-21.48-.46-32.18.07-5.92.3-6.13-2.39-6.1-6.94.16-27.08.08-54.16.08-81.24,0-26.8.12-53.6-.11-80.4-.05-5,.91-7,6.41-6.78,10.15.45,20.33.25,30.49.07,4-.07,6.11.41,6.1,5.32Q731,1918.19,731.19,2000.69Zm137.07-28.17c-.36,9.29-.31,18.62,0,27.92.14,4.15-1.26,5.15-5.25,5.13-31.07-.15-62.14-.23-93.2,0-6,.06-5.2-3.25-5.19-6.92q0-40.2,0-80.4c0-27.08.12-54.16-.11-81.24,0-5,.93-7,6.42-6.78,9.86.45,19.78.47,29.64,0,5.68-.27,7,1.68,7,7.09-.21,40.34.05,80.68-.28,121-.06,6.75,1.81,8.48,8.4,8.28,15.52-.5,31.07,0,46.6-.28C867.11,1966.3,868.44,1967.78,868.26,1972.52Zm136.55-109.94c.28,5.46-1.3,7.3-7,7.2-19.47-.35-38.95,0-58.42-.26-5.39-.08-7.59,1.11-7.08,6.89.62,7-2.25,16.29,1.28,20.44,4.13,4.86,13.74,1.46,21,1.61q19,.4,38.1,0c4.53-.09,6.52.83,6.28,5.91-.42,8.71-.42,17.48,0,26.2.24,5-1.67,6-6.24,5.94-17.78-.24-35.57.12-53.34-.22-5.55-.11-7.49,1.42-7,7a118,118,0,0,1,0,17.74c-.32,4.65,1.49,5.6,5.77,5.56,20-.2,40.09.08,60.12-.21,5.16-.08,6.9,1.23,6.62,6.55a246.4,246.4,0,0,0,0,26.21c.3,5.44-1.67,6.48-6.7,6.45q-51.23-.31-102.46,0c-4.9,0-6-1.47-6-6.14.21-27.34.11-54.69.11-82,0-26.5.26-53-.19-79.49-.11-6.62,1.9-7.74,8-7.69q49.53.46,99.06,0c6.05,0,8.69,1.09,8.18,7.79A192.73,192.73,0,0,0,1004.81,1862.58Zm172.61,93.94c0,14.09-.18,28.19.1,42.28.1,4.83-.67,7.07-6.32,6.83-11.27-.47-22.58-.36-33.85,0-4.31.13-6.48-1.44-8.41-5.11-17.57-33.3-37-65.62-52.91-99.8-2.28-.86-2.22.87-2.18,2.16.27,9.5-.82,19,.56,28.51.53,22.53.88,45.07,1.69,67.6.19,5.15-.93,6.89-6.33,6.66-10.43-.44-20.88-.31-31.32,0-4.33.11-5.79-1.07-5.78-5.62q.22-82,0-164c0-4.72,1.85-5.66,6-5.59,11.57.2,23.14.16,34.71,0,3.45,0,5.63.86,7.36,4.14,17.81,33.81,37.74,66.5,53.59,101.35,2.32,1,2.2-.83,2.17-2.07-.23-8.92.72-17.86-.53-26.75-.57-23.11-.93-46.21-1.85-69.3-.23-6,1.52-7.74,7.41-7.44a260.22,260.22,0,0,0,27.93,0c6.23-.34,8.15,1.38,8.1,7.88C1177.26,1877.61,1177.42,1917.06,1177.42,1956.52Zm149.8,40.44c-19.88,14.7-59.14,15.85-81.42,2.77-33.61-19.74-44.29-50.91-43.09-87.39.85-25.63,9.82-48.2,29.25-66,26.28-24.13,66.06-22.86,89.51-11.28,6.32,3.12,10.38,7.48,9.4,15.84-1,8.84-.24,17.89-.24,27.4-26.9-13.61-53.25-19.29-75.38,6.53-14.32,16.69-14.37,50,0,66.37,22.93,26.26,49.71,19.83,77,5.25,0,11.7-.16,22.61.08,33.52C1332.38,1993.89,1329.63,1995.18,1327.22,1997Zm145.45-158.79a230.68,230.68,0,0,0-.05,25.36c.19,4.84-1.47,6.27-6.26,6.21-19.75-.23-39.52.11-59.27-.23-5.56-.09-7.44,1.42-7,7,.6,7-2.12,16,1.35,20.45,3.74,4.75,13.19,1.34,20.13,1.49q19.47.43,39,0c4.68-.11,6.39,1.1,6.17,6-.39,8.72-.43,17.49,0,26.21.26,5.19-1.93,5.87-6.36,5.82-17.78-.21-35.57.15-53.34-.22-5.72-.13-7.36,1.7-6.91,7.14a83.56,83.56,0,0,1,0,16c-.68,6.3,2,7.28,7.6,7.19,19.47-.34,39,.06,58.42-.26,5.33-.09,6.76,1.51,6.51,6.67-.42,8.71-.33,17.48,0,26.2.16,4.54-.8,6.39-5.92,6.36q-51.65-.34-103.3,0c-5.07,0-5.9-1.72-5.86-6.24.19-27.06.09-54.13.09-81.19,0-26.78.16-53.56-.13-80.34-.06-5.62,1-7.66,7.19-7.59q49.95.51,99.92,0C1470.82,1830.21,1473.13,1831.64,1472.67,1838.17ZM1597,2005.57c-4.21.06-5-3.18-6.53-5.59q-22.61-35.14-45.07-70.49c-3,1.53-1.61,4.08-1.62,6-.12,21.16-.25,42.32,0,63.48.07,5.17-1.21,6.86-6.54,6.64-10.15-.43-20.35-.48-30.49,0-5.64.27-6.35-2-6.33-6.83q.23-80.83,0-161.66c0-5,1.1-6.92,6.51-6.84,25.13.38,50.29-.17,75.41.63,30,1,48.43,17,51.45,43.43,3.29,28.79-9.83,47.52-40.43,56.4l49.44,74.73C1626.74,2005.49,1611.88,2005.36,1597,2005.57Z"
                  />
                </g>
              </g>
            </svg>
          </section>

          <section className="zoom_panel quote">
            <div className="quote_text">
              <div className="member--inner">
                <h2>Face Yourself.</h2>
                <p>This is all we wanna say.</p>
                <div className="moreWrap">
                  <Link to="/company">SEE OUR COMPANY</Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default MemberReveal;
